export default "__VITE_ASSET__CH9u0MAY__"